import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { PopupTriggerProps } from '@atlassian/jira-development-board-common/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './src/ui/commit-details-popup-view/__generated__/CommitDetailsPopupViewQuery$parameters';
import type { CommitDetailsPopupViewQuery } from './src/ui/commit-details-popup-view/__generated__/CommitDetailsPopupViewQuery.graphql';

/**
 * @deprecated This component is deprecated. Please use the component from
 * "@atlassian/jira-development-board-commit-details-popup-new" package instead.
 */
export const commitDetailsEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			commitDetailsForIssue: CommitDetailsPopupViewQuery;
		},
		{},
		PopupTriggerProps,
		{}
	>,
	{
		issueId: string;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-commit-details-popup" */ './src/ui/commit-details-popup-view/CommitDetailsPopupView.tsx'
			),
	),
	getPreloadProps: ({ issueId }: { issueId: string }) => ({
		queries: {
			commitDetailsForIssue: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					issueId,
				},
			},
		},
	}),
});
